import PhotoSwipe from '@PhotoSwipe'
import PhotoSwipeLightbox from '@PhotoSwipeLightbox'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'
import $ from 'jquery'

const $items = $('.item-link')
const galleryItems = []

$items.each((idx, el) => {
  const $item = $(el)
  const type = $item.data('gallery-type')
  const src = $item.data('gallery-src')
  const width = $item.data('gallery-width')
  const height = $item.data('gallery-height')
  const caption = $item.data('gallery-caption')

  if (type === 'image') {
    galleryItems.push({
      src, width, height, caption,
    })
  } else if (type === 'video') {
    galleryItems.push({
      html: `<div class="ng-pswp-video-slide"><div class="responsive-embed">${src}</div></div>`,
    })
  }
})

const lightbox = new PhotoSwipeLightbox({
  dataSource: galleryItems,
  pswpModule: PhotoSwipe,
})
new PhotoSwipeDynamicCaption(lightbox, {
  type: 'below',
  captionContent: (slide) => {
    const html = []
    if (slide.data.caption) {
      html.push(slide.data.caption)
    }
    return html.join('<br>')
  },
})
lightbox.init()

$items.on('click', (ev) => {
  ev.preventDefault()
  lightbox.loadAndOpen($items.index(ev.currentTarget))
})
